import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../lib/api';

const TenantContext = createContext(null);

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};

function detectTenantSlug() {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  // Path-based: /loja/veststock
  const pathMatch = pathname.match(/^\/loja\/([a-zA-Z0-9_-]+)/);
  if (pathMatch) return pathMatch[1];

  // Subdomain-based: veststock.app.8ip.com.br
  if (hostname.includes('8ip.com.br')) {
    const parts = hostname.split('.');
    // e.g., veststock.app.8ip.com.br -> parts[0] = 'veststock'
    if (parts.length > 3 && parts[0] !== 'app') {
      return parts[0];
    }
  }

  // Preview env: subdomain.vendas-estoque-hub.preview.emergentagent.com
  if (hostname.includes('preview.emergentagent.com')) {
    const parts = hostname.split('.');
    // Main preview = vendas-estoque-hub.preview.emergentagent.com (3 parts)
    // Sub = veststock.vendas-estoque-hub.preview.emergentagent.com (4+ parts)
    if (parts.length > 4) {
      return parts[0];
    }
  }

  return null;
}

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);
  const [tenantSlug, setTenantSlug] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const slug = detectTenantSlug();
    setTenantSlug(slug);

    if (slug) {
      resolveTenant(slug);
    } else {
      setLoading(false);
    }
  }, []);

  const resolveTenant = async (slug) => {
    try {
      const { data } = await axios.get(`${API}/tenant/resolve?subdomain=${slug}`);
      setTenant(data);
    } catch (err) {
      setError('Loja não encontrada');
      setTenant(null);
    } finally {
      setLoading(false);
    }
  };

  const isTenantSite = !!tenantSlug;
  const isMainSite = !tenantSlug;

  return (
    <TenantContext.Provider value={{ tenant, tenantSlug, isTenantSite, isMainSite, loading, error }}>
      {children}
    </TenantContext.Provider>
  );
};
